module.exports = __webpack_public_path__ + "static/media/ll-solutions.2fbd5a0d.png";